export default ({userPreferences}) => ({
	userId: userPreferences?.userId,
	firstName: userPreferences?.firstName,
	lastName: userPreferences?.lastName,
	EmailAddress: userPreferences?.emailAddress
});
